import { z } from 'zod';

import type {
  ReverseShipmentDepartureRequest,
  ReverseShipmentDepartureResponse,
} from './reverse-shipment-departure.dto.js';
import { ShipmentHeaderSchema, ShipmentTotalsSummarySchema } from './shipments-shared.schema.js';

export const ReverseShipmentDepartureRequestSchema: z.ZodType<ReverseShipmentDepartureRequest> = z
  .object({
    companyId: z.uuid(),
    shipmentId: z.uuid(),
    stationId: z.uuid(),
    reasonCode: z.string().trim().min(1).max(64),
    reasonText: z.string().trim().min(1).max(500),
  })
  .strict();

export const ReverseShipmentDepartureResponseSchema: z.ZodType<ReverseShipmentDepartureResponse> = z
  .object({
    shipment: ShipmentHeaderSchema,
    totals: ShipmentTotalsSummarySchema,
    releasedLockCount: z.number().int().nonnegative(),
    reversedHoldingUnitIds: z.array(z.uuid()),
  })
  .strict();
